import styled from "react-emotion";

export const Title = styled.div``;
export const Content = styled.div``;
export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;
